/*
 * prescription (zod)
 */
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { prescriptions } from "./prescription.schema"

/* Select */
export type Prescription = z.infer<typeof selectPrescriptionSchema>
export const selectPrescriptionSchema = createSelectSchema(prescriptions)

/* Filters */
export type PrescriptionFilters = z.infer<typeof prescriptionFiltersSchema>
export const prescriptionFiltersSchema = z.object({
	id: z.string().optional(),
	patientId: z.string().optional(),
	practitionerId: z.string().optional(),
	appointmentId: z.string().optional(),
	isLatest: z.boolean().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createPrescriptionSchema = createInsertSchema(prescriptions).partial(
	globalCreateExclude,
)
export type CreatePrescription = z.infer<typeof createPrescriptionSchema>

/* Update */
export const updatePrescriptionSchema = createInsertSchema(prescriptions)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdatePrescription = z.infer<typeof updatePrescriptionSchema>
